const SUCCESS = 0;

export { SUCCESS }